import { application } from 'src/utils'
import { customerContainer, storeContainer } from 'src/models'
import { countryData } from 'src/views/components/SignUpForms/countryCodeData'
import { getLocaleCodeFromUrl } from 'src/utils/localeUtils'
const renderUserInviteFormInput = props => {
  const { isFromUserListCard = false } = props
  const storeIdBasedOnCountry = storeContainer?.storeIDValue
  let homeCountry = ''
  customerContainer?.profileResponse?.accounts?.properties?.forEach(element => {
    if (element.attributeId === 'countryCode') {
      homeCountry = element.value
    }
  })
  let phoneCountryCodeOptions = []
  countryData()?.forEach(val => phoneCountryCodeOptions.push(val))
  const localCountry = getLocaleCodeFromUrl()?.split('_')?.[1] || ''
  let inputCode = countryData()?.find(
    element => element.value === localCountry
  )?.value
  const formInput = [
    [
      {
        name: 'required_note',
        type: 'label',
        columnType: {
          lg: '12',
        },
        customClassName: isFromUserListCard ? 'd-none' : 'my-1 required-note',
      },
    ],
    [
      {
        name: 'firstName',
        ariaLabel: 'firstName',
        columnType: {
          lg: '6',
        },
        dataTestId: 'qa-first-name',
        maxLength: 50,
        placeholderKey: 'firstNamePlaceholder',
        customClassName: isFromUserListCard
          ? 'd-none'
          : 'associateInvitation firstName',
      },
      {
        name: 'lastName',
        ariaLabel: 'lastName',
        columnType: {
          lg: '6',
        },
        dataTestId: 'qa-last-name',
        maxLength: 50,
        customClassName: isFromUserListCard
          ? 'd-none'
          : 'associateInvitation firstName',
        placeholderKey: 'lastNamePlaceholder',
      },
    ],
    [
      {
        name: 'email',
        dataTestId: 'qa-email',
        placeholderKey: 'emailAddressPlaceHolder',
        columnType: {
          lg: '6',
        },
        maxLength: 254,
      },
      {
        name: 'phoneCountryCode',
        labelKey: 'optionalPhoneCountryCode',
        type: 'select',
        options: [...phoneCountryCodeOptions],
        columnType: {
          lg: `${
            application?.width > 1024 && application?.width < 1080 ? '0' : '2'
          }`,
          md: '6',
        },
        dataTestId: 'qa-dropdown-countrycode',
        defaultValue: inputCode,
        ariaLabel: 'phoneCountryCode',
        required: false,
        phoneNumberDropDown: true,
        disabled: homeCountry !== storeIdBasedOnCountry ? true : false,
      },
      {
        name: 'phoneNumber',
        labelKey: 'optionalPhone',
        columnType: {
          lg: `${
            application?.width > 1024 && application?.width < 1080 ? '0' : '4'
          }`,
          md: '6',
        },
        dataTestId: 'qa-create-account-phone',
        placeholderKey: 'phoneNoPlaceHolder',
        defaultValue: '',
        ariaLabel: 'mobilePhoneNumber',
        disabled: homeCountry !== storeIdBasedOnCountry ? true : false,
        required: false,
        maxLength: 15,
        type: 'mask',
      },
    ],
  ]
  return formInput
}
export { renderUserInviteFormInput }
